import { forwardRef } from 'react'
import { cn } from '../utils/cn.ts'
import { Avatar } from '../components/Avatar.tsx'

export interface EventCoverProps {
  title: string
  hostName: string
  hostAvatarSrc?: string
  src?: string
  className?: string
}

export const EventCover = forwardRef<HTMLDivElement, EventCoverProps>(
  ({ title, hostName, hostAvatarSrc, src, className }, ref) => {
    return (
      <div ref={ref} className={cn(src ? 'event-cover has-image' : 'event-cover', className)}>
        {src ? (
          <>
            <img src={src} alt="" className="event-cover-image-bg" />
            <div className="event-cover-image-overlay" />
          </>
        ) : (
          <div className="event-cover-gradient" />
        )}
        <div className="event-cover-content">
          {src ? (
            <>
              <div className="event-cover-invitation-row">
                <Avatar name={hostName} size="sm" src={hostAvatarSrc} />
                <p className="event-cover-invited">{hostName} invited you to</p>
              </div>
              <h2 className="event-cover-title">{title}</h2>
            </>
          ) : (
            <>
              <Avatar name={hostName} size="xl" src={hostAvatarSrc} />
              <p className="event-cover-invited">{hostName} invited you to</p>
              <h2 className="event-cover-title">{title}</h2>
            </>
          )}
        </div>
      </div>
    )
  },
)

EventCover.displayName = 'EventCover'
